export const BUSINESS = {
    name: "Southeast Stump Grinding",
    location: "Poplar Bluff, MO",
    phoneDisplay: "(573) 300-8625",
    phoneTel: "tel:5733008625",
    phoneSms:
        "sms:5733008625?&body=" +
        encodeURIComponent(
            "Hi Southeast Stump Grinding — here's a photo of my stump. My address is: "
        ),
    email: "southeast.stump@gmail.com",
    hours: "Mon–Sat · 7:00 AM – 6:00 PM",
    radius: "30-mile radius around Poplar Bluff, MO",
    payments: ["Cash", "Card", "Other payment options available"],
};

export const SIZE_PRICING = [
    { size: '10"', price: 150 },
    { size: '15"', price: 150 },
    { size: '20"', price: 185 },
    { size: '25"', price: 220 },
    { size: '30"', price: 255 },
    { size: '35"', price: 290 },
    { size: '40"', price: 325 },
    { size: '45"', price: 360 },
    { size: '50"', price: 395 },
    { size: '60"', price: 465 },
    { size: '70"', price: 535 },
];

export const DIFFICULTY = [
    { label: "Easy open front yard", add: "$0", min: 0, max: 0 },
    { label: "Backyard but easy access", add: "+$25", min: 25, max: 25 },
    { label: "Narrow / difficult access", add: "+$50–$100", min: 50, max: 100 },
    { label: "Major exposed roots", add: "+$50–$200", min: 50, max: 200 },
    { label: "Very hard / old stump", add: "+$25–$75", min: 25, max: 75 },
    { label: "Rocky soil", add: "+$50–$150", min: 50, max: 150 },
    { label: "Close to fence / building", add: "+$50–$150", min: 50, max: 150 },
    { label: "Significant slope", add: "+$50–$150", min: 50, max: 150 },
    { label: "Extra-deep grinding", add: "+$50–$150", min: 50, max: 150 },
];

export const CLEANUP_UPSELLS = [
    { label: "Haul chips / debris", add: "+$50–$150", min: 50, max: 150 },
    { label: "Topsoil", add: "+$50–$100", min: 50, max: 100 },
    { label: "Seed + straw", add: "+$50–$100", min: 50, max: 100 },
    { label: "Full lawn restoration", add: "+$100–$200+", min: 100, max: 200 },
];

export const STANDARD_SERVICE =
    'Grind stump 6–8" below grade + rake grindings back into hole.';

import TOWN_PAGES from "../data/towns.json";

export { TOWN_PAGES };
export const TOWNS = TOWN_PAGES.map((t) => t.name);

export const IMAGES = {
    heroRings:
        "https://images.unsplash.com/photo-1476589143317-647df3b59c32?q=80&w=2000&auto=format&fit=crop",
    chainsawLogs:
        "https://images.unsplash.com/photo-1696883186987-299ff16b0cac?q=80&w=1600&auto=format&fit=crop",
    woodChips:
        "https://images.unsplash.com/photo-1742931659660-6721406d1ba5?q=80&w=1600&auto=format&fit=crop",
    stumpField:
        "https://images.unsplash.com/photo-1663642438740-0e6fa5448428?q=80&w=1600&auto=format&fit=crop",
    woodSlab:
        "https://images.unsplash.com/photo-1522092663698-61ab4b1aa6a7?q=80&w=1600&auto=format&fit=crop",
    weatheredStump:
        "https://images.unsplash.com/photo-1775901952884-74511bce54e4?q=80&w=1600&auto=format&fit=crop",
    chipTexture:
        "https://images.unsplash.com/photo-1615195695780-bb72bdeda718?q=80&w=1600&auto=format&fit=crop",
};
